module.exports = __webpack_public_path__ + "static/media/icon-folder.3b32e628.svg";